<template>
<div class="chapter">
<div class="inner_page">
<p class="C123"><em><a id="page_x">Contents</a></em></p><a id="page_x">
</a><p class="C124"><a id="page_x"><em></em></a><em><a href="#/xhtml/07_Foreword#page_xii" id="id_1219">Foreword</a> by Joan Waugh</em></p>
<p class="C125"><em><a href="#/xhtml/08_Acknowledgments#page_xiv" id="id_1220">Acknowledgments</a></em></p>
<p class="C110"><a href="#/xhtml/10_Historians_and_Intellectual_Life#page_1" id="id_1221">Historians and Intellectual Life in the Civil War Era</a></p>
<p class="C124"><em>Lorien Foote</em></p>
<p class="C110"><a href="#/xhtml/11_U_S__Sanitary_Commission_Physici#page_19" id="id_1222">U.S. Sanitary Commission Physicians and the Transformation of American Health Care</a></p>
<p class="C124"><em>Kathryn Shively Meier</em></p>
<p class="C110"><span href="#/xhtml/12_Civil_War_Cybernetics__Medicine#page_41" id="id_1211" title="Link target outside of Sample">Civil War Cybernetics: Medicine, Modernity, and the Intellectual Mechanics of Union</span></p>
<p class="C124"><em>Susan-Mary Grant</em></p>
<p class="C110"><span href="#/xhtml/13_To_Save_the_Afflicted_Union__Rac#page_64" id="id_1212" title="Link target outside of Sample">To Save the Afflicted Union: Race, Civic Health, and the Sanitary Front</span></p>
<p class="C124"><em>Richard Newman</em></p>
<p class="C110"><span href="#/xhtml/14_John_Codman_Ropes__A_Lawyer_s_Hi#page_87" id="id_1213" title="Link target outside of Sample">John Codman Ropes: A Lawyer’s Historian</span></p>
<p class="C124"><em>Richard F. Miller</em></p>
<p class="C110"><span href="#/xhtml/15_Save_a_School_to_Save_a_Nation#page_110" id="id_1214" title="Link target outside of Sample">Save a School to Save a Nation: Faculty Responses to the Civil War at Midwestern Universities</span></p>
<p class="C124"><em>Julie Mujic</em></p>
<p class="C110"><span href="#/xhtml/16_Lessons_of_War__Three_Civil_War#page_129" id="id_1215" title="Link target outside of Sample">Lessons of War: Three Civil War Veterans and the Goals of Postwar Education</span></p>
<p class="C124"><em>Kanisorn Wongsrichanalai</em></p>
<p class="C110"><span href="#/xhtml/17_The_Rebels__Last_Device___Theod#page_153" id="page_xi" title="Link target outside of Sample">“The Rebels’ Last Device”: Theodore R. Davis and Faithful Representations of Black Soldiers during the Civil War</span></p>
<p class="C124"><em>Niki Lefebvre</em></p>
<p class="C110"><span href="#/xhtml/18_For_Their_Adopted_Home__Native_N#page_174" id="id_1216" title="Link target outside of Sample">For Their Adopted Home: Native Northerners in the South during the Secession Crisis</span></p>
<p class="C124"><em>David Zimring</em></p>
<p class="C110"><span href="#/xhtml/19_Thomas_F__Meagher__Patrick_R__Gu#page_193" id="id_1223" title="Link target outside of Sample">Thomas F. Meagher, Patrick R. Guiney, and the Meaning of the Civil War for Irish America: The Questions of Nationalism, Citizenship, and Human Rights</span></p>
<p class="C124"><em>Christian G. Samito</em></p>
<p class="C110"><span href="#/xhtml/20_This_Most_Unholy_and_Destructiv#page_217" id="id_1224" title="Link target outside of Sample">“This Most Unholy and Destructive War”: Catholic Intellectuals and the Limits of Catholic Patriotism</span></p>
<p class="C125"><em>William Kurtz</em></p>
<p class="C124"><em><span href="#/xhtml/21_Notes#page_237" id="id_1218" title="Link target outside of Sample">Notes</span></em></p>
<p class="C124"><em><span href="#/xhtml/22_List_of_Contributors#page_289" id="id_1217" title="Link target outside of Sample">List of Contributors</span></em></p>
<p class="C124"><em><span href="#/xhtml/23_Index#page_293" id="id_1225" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?4b5ee620